import { NotificationProviders, type SlackChannel } from "@doitintl/cmp-models";
import * as yup from "yup";

import { createReferencedTextAreaSchema } from "../../../ApiActionParametersForm/useApiActionParametersSchema";
import { type NodeWitOutputModel } from "../../../Common/hooks/useReferenceableNodes";

export function generateNotificationSchema(referenceableNodes: NodeWitOutputModel[]) {
  return yup
    .object({
      notificationProvider: yup
        .mixed<NotificationProviders>()
        .test(
          "not-empty-array",
          "Notification provider is required",
          (value: NotificationProviders | null | undefined) =>
            value !== null &&
            value !== undefined &&
            [NotificationProviders.EMAIL, NotificationProviders.SLACK].includes(value)
        )
        .default(NotificationProviders.EMAIL),

      message: createReferencedTextAreaSchema({
        referenceableNodes,
        isRequired: true,
      }),
      slackChannel: yup
        .mixed<SlackChannel>()
        .default(undefined)
        .when("notificationProvider", {
          is: NotificationProviders.SLACK,
          then: (schema) =>
            schema
              .required()
              .default({} as SlackChannel)
              .label("Slack channel")
              .test(
                "not-empty-object",
                "Slack channel cannot be an empty object",
                (value) => value !== undefined && value !== null && Object.keys(value).length > 0
              ),
          otherwise: (schema) => schema.strip(),
        }),

      emailRecipient: yup
        .string()
        .default(undefined)
        .trim()
        .when("notificationProvider", {
          is: NotificationProviders.EMAIL,
          then: (schema) => schema.default("").trim().label("Email recipient").required().email(),
          otherwise: (schema) => schema.strip(),
        }),
    })
    .noUnknown();
}
